'use client';

import type { LangCode } from './locales-config';

import i18next from 'i18next';
import { CONFIG } from '@/global-config';
import { getStorage } from 'minimal-shared/utils';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next, I18nextProvider as Provider } from 'react-i18next';

import { i18nOptions, fallbackLng, storageConfig, i18nResourceLoader } from './locales-config';

let i18nextLng: LangCode | undefined;

if (CONFIG.isStaticExport) {
  const storedLang = getStorage(
    storageConfig.localStorage.key,
    storageConfig.localStorage.autoDetection ? undefined : fallbackLng
  );
  i18nextLng = storedLang as LangCode;
}

const options = i18nOptions(i18nextLng); // конфигурация с detection

i18next.use(LanguageDetector).use(initReactI18next).use(i18nResourceLoader).init(options);

type I18nProviderProps = {
  lang?: LangCode;
  children: React.ReactNode;
};

export function I18nProvider({ lang, children }: I18nProviderProps) {
  if (lang && i18next.language !== lang) {
    i18next.changeLanguage(lang);
  }
  return <Provider i18n={i18next}>{children}</Provider>;
}
